import React from 'react';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import ClientsSection from '../components/ClientsSection';
import ContactSection from '../components/ContactSection';
import TeamPreview from '../components/TeamPreview';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <ServicesSection />
      <TeamPreview />
      <ClientsSection />
      <ContactSection />
    </>
  );
};

export default HomePage;
